import Constants from "@/constants"
import api from '../../api/docomo'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  get: (state) => (id) => {
    const s = state.all.find((v) => parseInt(v.id) === parseInt(id))
    const c = Constants.DOCOMO_SERVICE_AREAS.find((a) => a.id == id)
    const m = s && Object.assign(s, c)

    return m || {}
  }
}

const actions = {
  fetch ({ commit, rootGetters }, id) {
    const token = rootGetters['user/getBearerToken'](id)
    return new Promise((resolve) => {
      api.getServiceArea(id, token)
        .then(serviceArea => {
          commit('pushServiceArea', serviceArea)
          resolve()
        })
    })
  }
}

const mutations = {
  resetAll (state) {
    state.all = []
  },
  pushServiceArea (state, serviceArea) {
    state.all.push(serviceArea)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
